/* eslint-disable no-self-assign */
/* eslint-disable require-yield */

// import get from 'lodash/get'
import companyApi from '@/api/company'
import get from 'lodash/get'

const INITIAL_STATE = {
  dnsRecord: null,
  companyList: null,
}

export default {
  namespace: 'company',

  state: INITIAL_STATE,

  reducers: {
    setDnsRecord(state, { payload }) {
      return { ...state, dnsRecord: payload }
    },
    setCompanyList(state, { payload }) {
      return { ...state, companyList: payload }
    },
  },

  effects: {
    *createDomain({ payload, successCallback, errorCallback }, { select, call }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(companyApi.createDomain, {
        data: payload,
        accountId: get(account, 'accountId'),
      })

      const { status } = response

      if (status === 200) {
        successCallback?.()
      } else {
        errorCallback?.()
      }
    },

    *getDNS({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(companyApi.getDNS, {
        accountId: get(account, 'accountId'),
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'company/setDnsRecord', payload: resData.data })

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCompanyData({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(companyApi.getCompanyData, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'company/setCompanyList', payload: resData })
        successCallback?.()
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *createCompany({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(companyApi.createCompany, {
        data: {
          ...payload,
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { success } = resData
        if (success) {
          hasError = false
          successCallback?.()
        }
      }

      if (hasError) {
        yield put({ type: 'app/notify', payload: { message: resData?.message, severity: 'error' } })
        errorCallback?.(resData?.message)
      }
    },

    *editCompany({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(companyApi.editCompany, {
        data: {
          ...payload,
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { success } = resData
        if (success) {
          hasError = false
          successCallback?.()
        }
      }

      if (hasError) {
        yield put({ type: 'app/notify', payload: { message: resData?.message, severity: 'error' } })
        errorCallback?.(resData?.message)
      }
    },

    *deleteCompany({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(companyApi.deleteCompany, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

  },
}
